export default __webpack_public_path__ + "static/media/bullySits.790e8acb.png";